export const pageAction = pageName => {
    return{
        type: 'changePage',
        pageName: pageName
    }
}